import styled from 'styled-components';
import {Space} from 'antd';

const StyledInvoiceTabContainer = styled(Space)`
  position: relative;
  width: 100%;

  .amount {
    text-wrap: nowrap;
  }

  .invoice-match {
    align-items: center;
    justify-content: center;
    display: flex;

    &:hover {
      cursor: unset;
    }

    svg {
      height: 24px;
      width: 24px;
    }
  }

  .invoice-type {
    display: flex;
  }
`;



export {
  StyledInvoiceTabContainer,
};
